<template>
  <nav class="navbar">
    <div class="nav-container">
      <div class="nav-brand">
        <LogoComponent :width="120" :height="40" />
      </div>
      
      <div class="nav-links">
        <a href="#features" class="nav-link" @click.prevent="navigateToSection('#features')">功能特色</a>
        <a href="#pricing" class="nav-link" @click.prevent="navigateToSection('#pricing')">套餐价格</a>
        <a href="#" class="nav-link" @click.prevent="navigateToInstall">安装指南</a>
        <a href="#" class="nav-link" @click.prevent="navigateToQuickStart">快速入门</a>
        <span class="demo-label">展示页面</span>
      </div>
      
      <div class="nav-actions">
        <span class="demo-badge">仅作展示</span>
      </div>
    </div>
  </nav>
  
</template>

<script>
import LogoComponent from './LogoComponent.vue'

export default {
  name: 'NavBar',
  components: {
    LogoComponent
  },
  inject: ['setCurrentPage'],
  methods: {
    navigateToSection(sectionId) {
      this.setCurrentPage('home');
      // 延迟滚动到指定位置
      setTimeout(() => {
        const element = document.querySelector(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    },
    navigateToHome() {
      this.setCurrentPage('home');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    navigateToInstall() {
      this.setCurrentPage('install');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    navigateToQuickStart() {
      this.setCurrentPage('quick-start');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(250, 250, 250, 0.8);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  z-index: 100;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
}

.nav-brand {
  display: flex;
  align-items: center;
}

.nav-links {
  display: flex;
  gap: 32px;
  align-items: center;
}

.nav-link {
  color: #374151;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  transition: color 0.2s ease;
}

.nav-link:hover {
  color: #0f0f23;
}

.nav-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.demo-label {
  color: #f59e0b;
  font-weight: 600;
  font-size: 14px;
  background: #fef3c7;
  padding: 4px 12px;
  border-radius: 16px;
  border: 1px solid #f59e0b;
}

.demo-badge {
  background: #e2e8f0;
  color: #64748b;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #cbd5e1;
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
  }
  
  .nav-container {
    padding: 0 16px;
  }
}
</style>